import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'; // ← Add this near your other imp
import {
  Box,
  useToast,
  useColorModeValue,
  Text,
  Spinner,
  VStack,
  Heading,
} from "@chakra-ui/react";
import axios from "axios";
import { ExamManualAttemptDetails, ExamManualAttemptDetailsEval, ExamAttemptScoreStatus } from '../../../Platform/Common/types';
import ExamAttemptManualEvaluator from "../../../Platform/Components/ExamAttemptManualEvaluator";

const EvaluateB2CExamByAdmin = () => {

    const navigate = useNavigate(); // ← Initialize navigation

  const { exam_attempt_id } = useParams<{ exam_attempt_id: string }>();
  const examAttemptId = Number(exam_attempt_id);
  const toast = useToast();

  const [examManualAttemptDetails, setExamManualAttemptDetails] = useState<ExamManualAttemptDetails | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const cardBg = useColorModeValue("gray.50", "gray.700");

const handleManualSave = async (manualScoringData: ExamManualAttemptDetailsEval) => {
  const success = await saveManualAttemptToAPI(manualScoringData);
  if (success) {
    toast({
      title: "Evaluation overridden successfully.",
      status: "success",
      duration: 3000,
      isClosable: true,
    });

    navigate(-1); // or navigate("/admin/exam-scoring-status")
  }
};

  const saveManualAttemptToAPI = async (manualScoringData: ExamManualAttemptDetailsEval): Promise<boolean> => {
  try {
    const api = process.env.REACT_APP_API_URL || 'https://default-url.com';

    await axios.post<ExamAttemptScoreStatus>(
      `${api}/exam/scoring/manual-attempt/${manualScoringData.exam_attempt_id}`,
      manualScoringData,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }
    );

    return true;
  } catch (error) {
    console.error("Error saving evaluation:", error);
    toast({
      title: "Error occurred while saving override.",
      status: "error",
      duration: 4000,
      isClosable: true,
    });
    return false;
  }
};


  const fetchExamManualAttempt = async (exam_attempt_id: number) => {
    try {
      const api = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const { data } = await axios.get<ExamManualAttemptDetails>(
        `${api}/exam/attempt/${exam_attempt_id}/manual-question-details`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setExamManualAttemptDetails(data);
    } catch (err) {
      console.error(err);
      toast({ title: "Error fetching exam attempt details", status: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExamManualAttempt(examAttemptId);
  }, [examAttemptId]);

  return (
    <Box as="main" mx="auto" p={4}>
      <VStack align="start" spacing={4}>
        <Heading size="md" color="blue.600">
          Admin Manual Evaluation Override
        </Heading>
        <Text fontSize="sm" color="gray.600">
          You are now overriding the manual evaluation for this exam attempt. Any changes made here will overwrite previous tutor evaluations and will be recorded for audit purposes.
        </Text>
      </VStack>

      <Box mt={6} bg={cardBg} p={4} borderRadius="md" boxShadow="sm">
        {loading ? (
          <Spinner size="lg" />
        ) : examManualAttemptDetails ? (
          <ExamAttemptManualEvaluator
            examManualAttemptDetails={examManualAttemptDetails}
            onSubmit={handleManualSave}
          />
        ) : (
          <Text color="red.500">No data found for the specified exam attempt.</Text>
        )}
      </Box>
    </Box>
  );
};

export default EvaluateB2CExamByAdmin;
